const masterListStrings = {
  masterListHeader: {
    allMasterListsFilterItem: 'All Tests',
    createMasterListButton: 'Add Test',
    masterListFilterSearchBarPlaceholder: 'Test Name',
  },

  masterListList: {
    masterListGridNoResultsFound: 'No results matching your search criteria',
    masterListGridHeader: {
      masterListNameGridHeader: 'English Test Name',
      masterListArabicTestNameGridHeader: 'Arabic Test Name',
      masterListSearchableGridHeader: 'Searchable',
      masterListPriceGridHeader: 'Price',
    },
    masterListDistanceUnit(distance) {
      return `${distance} km`;
    },
    masterListPartnershipDistanceUnit(distance) {
      return `Partnership ${distance} km`;
    },
    masterListGridItemCount: 'Items',
  },

  masterListDetailsHeader: {},

  masterListDetailsContent: {
    masterListDetailsContentConfirmButtonLabel: 'Add Test',
    masterListDetailsContentEditButtonLabel: 'Edit Test',
    masterListDetailsContentCancelButtonLabel: 'Cancel',
    masterListDetailsFormFieldKeys: {
      englishName: 'englishName',
      englishDescription: 'englishDescription',
      arabicName: 'arabicName',
      arabicDescription: 'arabicDescription',
      servicePrice: 'servicePrice',
      isSearchable: 'isSearchable',
    },
    masterListDetailsFormFields: {
      englishName: 'English Name',
      englishDescription: 'English Description',
      arabicName: 'Arabic Name',
      arabicDescription: 'Arabic Description',
      servicePrice: 'Service Price',
      isSearchable: 'Is Searchable',
      getFormFieldLabel(key) {
        return this[key];
      },
      formEmptyFieldError(key) {
        return `${this[key]} is required`;
      },
      formWrongFieldErrorText(key) {
        return `${this[key]} is incorrect`;
      },
    },
    masterListDetailsFormFieldsUnits: {
      servicePrice: 'EGP',
      getFormFieldUnit(key) {
        return this[key];
      },
    },
  },
};

export default masterListStrings;
